import { Intro } from "components/commons";
import locale from "localization";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import useDataTable from "hooks/useDataTable";
import { mapDataToList, mapFilterToRequest } from "./refund-transaction.mapper";
import useExport from "hooks/useExport";
import { generateReport } from "apis/generate-report.api";
import styles from "./refund-transaction.module.scss";
import initialFilterState from "./refund-transaction-filter.state";
import { StationContext } from "contexts";
import { useContext } from "react";
import RefundTransactionFilter from "./refund-transaction-filter";
import { refundTransactionColumn } from "./refund-transation-column";
import { TransactionStatusEnum } from "enums";
import { getTransactionsItems } from "apis";

const RefundTransactionModule = () => {
  const { station } = useContext(StationContext);

  const STATUS = TransactionStatusEnum.REFUND;

  const { filter, search, table } = useDataTable({
    api: {
      api: getTransactionsItems,
      params: {
        page: 1,
        perPage: 10,
        stationCode: station.stationCode,
        status: STATUS,
        orderBy: "createdAt",
        order: "desc",
      },
      mapper: (param) => {
        return param;
      },
    },
    filter: { initialState: initialFilterState(), mapper: mapFilterToRequest },
    table: {
      key: "transactionItems",
      mapper: (transactions) => mapDataToList({ transactions }),
      columns: refundTransactionColumn,
    },
  });

  const exports = useExport({
    api: generateReport,
    hasModal: false,
    reportType: "transaction-item",
    mappedFilterState: {
      ...filter?.mappedFilterState,
      searchKey: search?.searchKey,
      stationCode: station.stationCode,
      transactionStatus: STATUS,
      status: STATUS,
    },
  });

  return (
    <>
      <Intro title={locale.refundTransactionReport} />
      <RefundTransactionFilter {...filter} {...search} {...exports} />
      <div className={styles.table}>
        <DataTableV2 {...table} />
      </div>
    </>
  );
};

export default RefundTransactionModule;
